import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, AwardIcon, BookOpenIcon, LayoutGridIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: ClockIcon,
    title: 'Ahorro de Tiempo',
    description: 'No pierdas horas planificando. Tenés todo listo para aplicar directamente en el aula.'
  }, {
    icon: AwardIcon,
    title: 'Calidad Profesional',
    description: 'Recursos creados por docentes con años de experiencia en educación artística.'
  }, {
    icon: BookOpenIcon,
    title: 'Diseño Curricular',
    description: 'Contenidos alineados a los núcleos de aprendizaje prioritarios y diseño curricular argentino.'
  }, {
    icon: LayoutGridIcon,
    title: 'Versatilidad Total',
    description: 'Ideal tanto para escuelas formales como para talleres independientes o centros culturales.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="beneficios" className="w-full bg-white py-20 px-4" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-4">
            Beneficios del Mega Pack
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-5">
            Diseñado para hacer tu trabajo más fácil y efectivo
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-6">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <motion.div key={index} variants={itemVariants} className="bg-gray-50 rounded-xl p-8 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-7">
                <div className="inline-flex p-4 rounded-full bg-red-100 mb-6" data-id="element-8">
                  <Icon className="h-8 w-8 text-red-700" aria-hidden="true" data-id="element-9" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-10">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm" data-id="element-11">
                  {benefit.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}